<template>
<div class="bb-credit-note-table">
  <div class="bb-credit-note-table-body">
    <div class="bb-credit-note-table-row"
         v-for="row in filterRows"
         :key="row._id"
         :class="{'bb-credit-note-table-row-height': row.$accordionContent}"
         @mouseleave="openPopup = false"
    >
      <div class="bb-credit-note-table-row-wrapper
                  bb-credit-note-table-row-wrapper_start"
      >
        <div class="bb-credit-note-table-row-wrapper__checkbox"
             @click="clickCheckbox(row)"
        >
          <CircleCheckbox @change="rowChecked"
                          :disabled="row.status !== 1"
                          :value="row.status !== 1"
                          :item="row"/>
        </div>
        <div class="bb-credit-note-table-row-wrapper__name"
             @click.stop="openProforma(row)"
             :ref="`refund${row._id}`"
        >
          Tax Credit Note {{row.number}}
          <transition name="fade" mode="out-in">
            <div class="bb-credit-note-table-popup"
                 :style="popupPosition"
                 v-if="row.status === 2 && openPopup"
            >
              Tax credit Note is already included in Refund. Check Refund tab
            </div>
          </transition>
        </div>
        <div class="bb-credit-note-table-row-wrapper__button">
          <AccordionButton :list="row.transactions" :row="row"/>
        </div>
      </div>
      <div class="bb-credit-note-table-row-wrapper"
      >
        <div class="bb-credit-note-table-row-wrapper__balance">
          {{numeralConvertNumber(row.balance)}}
        </div>
      </div>
      <div class="bb-credit-note-table-row-transactions">
        <Transactions :row="row"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import CircleCheckbox from '@/components/Main/Inputs/CircleCheckbox'
import vSelect from 'vue-select'
import AccordionButton from '@/components/Main/AccordionButton/AccordionButton'
import convertNumber from '@/mixin/convertNumber'
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import Transactions from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/CreditNoteTable/Transactions'
import _ from 'lodash'
export default {
  name: 'CreditNoteTable',
  mixins: [convertNumber],
  components: {
    CircleCheckbox,
    AccordionButton,
    CustomSelect,
    Transactions,
    vSelect
  },
  props: ['rows', 'completeStatus'],
  computed: {
    filterRows () {
      return this.rows.filter(({status}) => this.completeStatus ? status === 3 : status !== 3)
    }
  },
  data () {
    return {
      defaultDeposit: {
        id: 1,
        name: 'Cash deposit'
      },
      listSelect: [
        {
          id: 1,
          name: 'Cash deposit'
        }
      ],
      openPopup: false,
      popupPosition: {}
    }
  },
  methods: {
    rowChecked (value, item) {
      this.$set(item, '$checked', value)
      this.$emit('addCreditNote', item)
    },
    clickCheckbox (row) {
      if (row.status === 2) {
        this.openPopup = !this.openPopup
        this.setPositionPopup(row)
      }
    },
    setPositionPopup (item) {
      const [ref] = _.get(this.$refs, `refund${item._id}`, [])
      if (ref) {
        const box = ref.getBoundingClientRect()
        const popups = ref
        const popupWidth = _.get(popups[0], 'offsetWidth', 0)
        const diffLeft = popupWidth / 2
        this.popupPosition = {
          left: (box.left - diffLeft + 5) + 'px',
          top: box.top + 30 + 'px'
        }
      }
    },
    openProforma (item) {
      this.$emit('openTaxCreditNote', item)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-credit-note-table {
    @include global-font;

    &-row {
      position: relative;
      display: grid;
      padding: 18px 0;
      align-items: center;
      border-top: 1px solid $color-wild-sand;
      grid-template-columns: minmax(488px, 2fr) 372px;

      &:first-child {
        border-top: none;
      }

      &-wrapper {
        display: inline-flex;
        justify-content: flex-end;
        align-items: center;

        &_between {
          justify-content: space-between;
        }

        &_start {
          justify-content: flex-start;
        }

        &-location {
          margin-left: 30px;
        }

        &_end {
          justify-content: flex-end;
        }

        &__name {
          padding-left: 8px;
          font-weight: bold;
          font-size: 14px;
          line-height: 17px;
          cursor: pointer;
          transition: 0.3s;

          &:hover {
            color: $color-accent;
          }
        }

        &__button {
          padding-left: 270px;
        }

        &-select {
          position: relative;
          display: flex;
          align-items: center;
          word-break: normal;
          justify-content: space-between;
          min-width: 121px;
          margin-left: 84px;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 500;
          font-size: 13px;
          line-height: 16px;
          height: 30px;

          &__option {
            font-weight: 500;
            font-size: 13px;
            line-height: 16px;
          }
        }

        &__refund {
          width: 87px;
          margin-left: 12px;
          text-transform: uppercase;
        }

        &__balance {
          font-weight: bold;
          font-size: 14px;
          line-height: 135.84%;
        }
      }

      &-transactions {
        grid-column: 1/3;
      }

      &-checked {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    &-popup {
      position: fixed;
      padding: 12px 12px;
      background-color: $color-white;
      color: $color-black;
      list-style: disc inside;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      box-shadow: 0 0 20px rgba($color-black, 0.1);
      border-radius: 5px;
      z-index: 12;
      pointer-events: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/CreditNoteTable/CreditNoteTable.vue